import React from 'react';
const ContentBlockIntroCopyCentered = ({ content }) => {
    return (React.createElement("section", { className: "mt-14 xl:mt-20 mb-8 px-6 max-w-[39.625rem] xl:max-w-[50.875rem] mx-auto" },
        React.createElement("p", { className: "text-2xl md:text-[2rem] xl:text-[2.5rem] leading-[140%] md:leading-[3rem] tracking-[-0.03em] text-[#656565]" }, content)));
};
export { ContentBlockIntroCopyCentered };
